import React, { Component } from 'react'
import QuizBullet from './QuizBullet'
import Axios from 'axios';

export class QuizBulletList extends Component {

  state = {
    categories: []
  }

  componentWillMount() {
    Axios.get(`http://web.wholechildapp.com/api/quizzes/` + this.props.api_link).then(res => {
      this.setState({
        categories: res.data.quiz.categories
      })
    })
  }

  handleChange = (input, e) => {
    this.setState({ [input]: e })
  }

  createPencil = () => {
    const { categories } = this.state;
    const { step } = this.props;
    if (categories) {
      return categories.map((bullet, index) =>
        <QuizBullet key={index}
          id={index}
          handleChange={this.handleChange}
          step={step}
          icon={bullet.icon}
          categoryName={bullet.name}
          colour={bullet.color} />
      )
    }
  }

  render() {
    return (
      <div>
        <section id="categories-bar">
          <div className="container">
            <div className="categories-bar">
              {this.createPencil()}
            </div>
          </div>
        </section>
        <div className="error-tooltip">
          <p>You have to choose an answer to each question before proceeding to the next category!</p>
        </div>
      </div>


    )
  }
}

export default QuizBulletList
